import Box, { BoxProps } from '@mui/material/Box';
import { useEffect, useRef, useState } from 'react';

export interface ScrollTriggerProps {
  onIntersected?: () => void;
  offsetFromEnd: BoxProps['bottom'];
}

export const ScrollTrigger = ({ offsetFromEnd, onIntersected }: ScrollTriggerProps) => {
  // To avoid onIntersected being stale in the observer callback
  const callbackRef = useRef(onIntersected);

  useEffect(() => {
    callbackRef.current = onIntersected;
  }, [onIntersected]);

  const [observer] = useState(
    // It is not being accessed during render, but in a callback so it should be ok
    // eslint-disable-next-line react-hooks/refs
    () =>
      new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          callbackRef.current?.();
        }
      })
  );

  const refCallback = (ref: HTMLDivElement) => {
    if (ref) {
      observer.observe(ref);

      return () => observer.unobserve(ref);
    }
    return undefined;
  };

  return (
    <Box
      ref={refCallback}
      position="absolute"
      bottom={0}
      left={0}
      right={0}
      height={offsetFromEnd}
      sx={{ zIndex: -1 }}
    />
  );
};
